import { render, staticRenderFns } from "./TkHotelReview.vue?vue&type=template&id=ea759c64&scoped=true&"
import script from "./TkHotelReview.vue?vue&type=script&lang=js&"
export * from "./TkHotelReview.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelReview.vue?vue&type=style&index=0&id=ea759c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea759c64",
  null
  
)

export default component.exports